import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { ChatServices } from '@app/services/chat.service';
import { ICustomInstructions } from '@common/models/Chat/ICustomInstructions';
import { ConfirmationService, MessageService } from 'primeng/api';

@Component({
  selector: 'app-custom-instructions-dialog',
  templateUrl: './custom-instructions-dialog.component.html',
  styleUrls: ['./custom-instructions-dialog.component.scss']
})
export class CustomInstructionsDialogComponent implements OnInit,OnDestroy {
  customInstructions: String[] = [];
  aboutUser: String[] = [];

  isLoading: boolean = true;
  enableInstructions: boolean = false;
  constructor(private confirmationService: ConfirmationService, private messageService: MessageService, private chatServices: ChatServices) { }

  @Input() showdialog: boolean;
  @Output() emitSummaryForDoc: EventEmitter<String[]> = new EventEmitter();
  @Output() closeDialog: EventEmitter<boolean> = new EventEmitter();
  typingTimer: any; // timeout holder
  doneTypingInterval = 500;

  ngOnInit(): void {
    this.fetchCustomInstructions();
  }

  ngOnDestroy() {
    if (this.typingTimer) {
      clearTimeout(this.typingTimer);
    }
  }

  onTextChangeDebounced() {
    clearTimeout(this.typingTimer);
    this.typingTimer = setTimeout(() => {
      this.checkDisable();
    }, this.doneTypingInterval);
  }

  fetchCustomInstructions() {
    // Simulate an API call to fetch older custom instructions
         this.chatServices.getcustomInstructions().subscribe((res: ICustomInstructions) => {
                if (res) {
                    this.enableInstructions = res.isEnabled;
                    this.customInstructions = res.vanillaChat.Instructions.map((instruction) => instruction.content);
                    this.aboutUser = res.vanillaChat.aboutUser.map((instruction) => instruction.content);
                    if(this.customInstructions[0] == "You are an AI assistant that helps people find information. "){
                      this.customInstructions[0] = null;
                    }
                    this.isLoading = false;
                }
            });
  }

  saveInstructions() {
    let partialInstructions: Partial<ICustomInstructions> = {
      isEnabled: this.enableInstructions,
      vanillaChat: {
        Instructions: this.customInstructions
          .filter(content => content && content !== "")
          .map(content => ({ content })),

        aboutUser: this.aboutUser
          .filter(content => content && content !== "")
          .map(content => ({ content })),
      }
    };
      this.chatServices.saveCustomInstructions(partialInstructions).subscribe((res: ICustomInstructions) => {
        if (res) {
            this.customInstructions = res.vanillaChat.Instructions.map((instruction) => instruction.content);
            this.isLoading = false;
        }
    });
  }

  checkDisable(){
    let disable=false;
    let isaboutUser =false;
    let iscustomInstructions=false;
    this.customInstructions.map((content) => {
      if(content && content!==""){
        iscustomInstructions=true;
      }
    }),
    this.aboutUser.map((content) => {
      if(content && content!==""){
        isaboutUser=true;
      }
    })
    if(!iscustomInstructions && !isaboutUser){
      this.enableInstructions=false;
    }

  }

  addInstruction() {
    this.customInstructions.push("");
  }

  emitSummary() {
    this.saveInstructions()
    this.emitSummaryForDoc.emit(this.customInstructions);
  }

  onClose() {
    this.closeDialog.emit(false);
  }

  toggleDialog() {
    this.showdialog = !this.showdialog;
}

}
